// US phone number helpers — mask as (###) ###-#### and validate NANP format.

export const formatPhone = (value: string): string => {
  const numbers = value.replace(/\D/g, '').slice(0, 10);
  if (numbers.length === 0) return '';
  if (numbers.length < 4) return `(${numbers}`;
  if (numbers.length < 7)
    return `(${numbers.slice(0, 3)}) ${numbers.slice(3)}`;
  return `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)}-${numbers.slice(6)}`;
};

export const getPhoneDigits = (value?: string): string =>
  (value || '').replace(/\D/g, '');

export const validatePhone = (value?: string): boolean => {
  // US number: exactly 10 digits.
  return /^\d{10}$/.test(getPhoneDigits(value));
};
